export enum GregorioClefType {
  C,
  F,
}
